<template>
  <div class="monitor">
    <div class="top">
      <a-row :gutter="16">
        <a-col :span="7">
          <a-input v-model="tag" addon-before="标签" placeholder="请输入标签" />
        </a-col>
        <a-col :span="7">
          <a-range-picker
            v-model="date_range"
            :show-time="{ format: 'HH:mm' }"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['起始时间', '结束时间']"
            @change="onChange"
          />
        </a-col>
        <a-col :span="10">
          <div class="btn-area">
            <a-button type="primary" @click="get_position">搜索</a-button>
            <div class="item">
              <div class="lebal">前端优化</div>
              <a-switch default-checked v-model="is_origin" @change="draw_line">
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
            </div>
            <div class="item">
              <div class="lebal">贝塞尔曲线</div>
              <a-switch default-checked v-model="is_bezier" @change="draw_line">
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
            </div>
            <div class="item">
              <div class="lebal">后端优化</div>
              <a-switch default-checked v-model="optimize" @change="get_position">
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="16" align="middle" style="margin-top: 30px">
        <a-col :span="18">
          <a-slider v-model="step" :min="1" :max="point_count" @afterChange="draw_line" />
        </a-col>
        <a-col :span="6">
          <a-button @click="change_step('sub')">上一步</a-button>
          <a-button @click="change_step('add')" style="margin-left: 12px">下一步</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="body">
      <canvas type="2d" id="myCanvas"></canvas>
    </div>
  </div>
</template>

<script>
import bezrer from './bezier.js'

export default {
  data() {
    return {
      tag: 'deca01001175caa3',
      date_range: ['2021-05-13 12:28:21', '2021-05-13 13:46:29'],
      // tag: 'deca01005474c211',
      // date_range: ['2021-04-08 10:10:00', '2021-04-08 10:13:00'],

      step: 0,
      point_count: 0,
      mid: null,
      pool_url: '',
      pool_width: '',
      ctx: null,
      map: null,
      map_w: 0,
      map_h: 0,
      dpr: 1,
      _list: [],
      list: [],
      scale: 0.5,

      is_origin: false,
      is_bezier: false,
      optimize: false,
    }
  },
  mounted() {
    this.mid = this.$route.query.mid

    this.get_pool()
  },
  methods: {
    change_step(type) {
      if (type == 'add') {
        this.step = this.step + 1
      } else {
        this.step = this.step - 1
      }

      this.draw_line()
    },
    format_position(position_list) {
      const list = []

      position_list.forEach((point, index) => {
        let distance1 = 0
        let distance2 = 0

        if (index > 0 && index < position_list.length - 1) {
          distance1 = Math.sqrt(Math.pow(point.x - position_list[index - 1].x, 2) + Math.pow(point.y - position_list[index - 1].y, 2))
          distance2 = Math.sqrt(Math.pow(point.x - position_list[index + 1].x, 2) + Math.pow(point.y - position_list[index + 1].y, 2))
        }

        if (distance1 < 500 && distance2 < 500) {
          list.push(point)
        }
      })

      const _list = []

      list.forEach((point, index) => {
        if (index % 3 == 0) {
          if (index > 1 && index < list.length - 2) {
            point.x = (list[index - 2].x + list[index - 1].x + point.x + list[index + 1].x + list[index + 2].x) / 5
            point.y = (list[index - 2].y + list[index - 1].y + point.y + list[index + 1].y + list[index + 2].y) / 5
          }
          _list.push(point)
        }
      })

      return _list
    },
    draw_map() {
      const canvas = document.getElementById('myCanvas')
      const ctx = canvas.getContext('2d')

      const img = document.createElement('img')
      img.src = this.pool_url
      img.onload = () => {
        canvas.width = canvas.clientWidth
        canvas.height = (canvas.width / img.width) * img.height

        const img_width = canvas.width
        const img_height = (img_width / img.width) * img.height
        ctx.drawImage(img, 0, 0, img_width, img_height)

        // this.draw_line(ctx, img_width / this.current.pool.width)
        // this.draw_line2(ctx, img_width / this.current.pool.width)
        this.map = img
        this.map_w = img_width
        this.map_h = img_height
        this.ctx = ctx
        this.dpr = img_width / this.pool_width
      }
    },
    draw_line() {
      this.ctx.clearRect(0, 0, this.map_w, this.map_h)
      this.ctx.drawImage(this.map, 0, 0, this.map_w, this.map_h)

      let list
      if (this.is_origin) {
        list = this.format_position(this.list)
      } else {
        list = [...this.list]
      }

      this.point_count = list.length

      list = list.splice(0, this.step)

      if (this.is_bezier) {
        this.draw_line1(list)
      } else {
        this.draw_line2(list)
      }
    },
    draw_line1(list) {
      let arr = []
      let p_list = []
      const ctx = this.ctx
      const dpr = this.dpr
      ctx.lineWidth = 2
      ctx.strokeStyle = '#1fef1c'
      ctx.beginPath()
      list.forEach((point, index) => {
        const ptx = point.x * dpr
        const pty = point.y * dpr
        p_list.push(ptx)
        p_list.push(pty)
      })
      bezrer(p_list, ctx)
    },
    draw_line2(list) {
      const ctx = this.ctx
      const dpr = this.dpr
      ctx.lineWidth = 2
      ctx.strokeStyle = 'rgba(0,0,0,.5)'
      ctx.beginPath()
      let _x, _y

      list.forEach((point, index) => {
        const y = point.y * dpr
        const x = point.x * dpr
        if (!index) {
          ctx.moveTo(x, y)
        } else {
          // const distance = Math.sqrt(Math.pow(Math.abs(point.x - _x), 2) + Math.pow(Math.abs(point.y - _y), 2))
          ctx.lineTo(x, y)
        }
        _y = point.y
        _x = point.x
      })
      ctx.stroke()
    },
    get_position() {
      this.$http({
        url: `stadium-tag-online`,
        method: 'get',
        params: {
          'filter[map_id]': this.mid,
          'filter[type]': '1',
          'filter[tag]': this.tag,
          'filter[create_time][gte]': this.date_range[0],
          'filter[create_time][lt]': this.date_range[1],
          optimize: this.optimize ? 1 : 0,
        },
      }).then((r) => {
        this.list = r.data.list
        this.step = r.data.list.length

        this.draw_line()
      })
    },
    get_pool() {
      this.$http({
        url: `stadium-pool/${this.mid}`,
        method: 'get',
      }).then((r) => {
        this.pool_url = 'https://oss.mcloud.moveclub.cn/' + r.data.map
        this.pool_width = r.data.width

        this.$nextTick(() => {
          this.draw_map()
        })
      })
    },
    onChange(value, dateString) {
      this.date_range = dateString
    },
  },
}
</script>

<style lang="less" scoped>
.monitor {
  max-width: 1440px;
  margin: 0 auto;
  padding: 80px 0;
  .body {
    margin-top: 20px;
    #myCanvas {
      width: 100%;
    }
  }
  .btn-area {
    display: flex;
    align-items: center;
    .item {
      display: flex;
      align-items: center;
      margin-left: 12px;
      .lebal {
        margin-right: 12px;
      }
    }
  }
}
</style>
